var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAd = function SvgAd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M6.783 22.81A11.953 11.953 0 0 0 12 24c1.87 0 3.64-.428 5.218-1.19L18.26 12 17.218 1.19A11.952 11.952 0 0 0 12 0c-1.87 0-3.64.428-5.217 1.19L5.739 12l1.044 10.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M17.217 22.81A12 12 0 0 0 23.999 12a12 12 0 0 0-6.782-10.809V22.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M6.783 22.81V1.19A12 12 0 0 0 0 12.001a12 12 0 0 0 6.783 10.808Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M12 16.173V12h3.13v1.565c0 .272-.521 1.268-1.81 2.087-.487.31-.992.41-1.32.521ZM12 8.869H8.87v3.13H12V8.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M13.565 7.826A1.043 1.043 0 0 0 12 6.923a1.043 1.043 0 0 0-1.565.903H7.826v5.218c0 1.942 1.543 3.065 2.752 3.647A1.043 1.043 0 0 0 12 18.12a1.044 1.044 0 0 0 1.422-1.429c1.21-.582 2.752-1.705 2.752-3.647V7.825h-2.609Zm1.044 5.218c0 .271 0 1.099-1.288 1.918a6.32 6.32 0 0 1-1.32.623 6.32 6.32 0 0 1-1.322-.623c-1.288-.82-1.288-1.646-1.288-1.918V9.39h5.218v3.652Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgAd;